"use client";
import EventHimss from "@/components/Events/EventHimss";

export default function EventHimssPage() {
  return <EventHimss />;
}
